import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a434c866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-part" }
const _hoisted_2 = { class: "table-btn" }
const _hoisted_3 = ["onClick"]

import Title from "@/components/Title.vue";
import ApproveFilter from "@/components/ApproveFilter.vue";
import { SIGNSURE } from "../../const/openManageTableList.ts";
import { message } from "ant-design-vue";
import { ref, reactive, onActivated } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getPendingApprovalList } from "@/api/approve";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const tableData = ref([]);
const pagination = reactive({
  current: 1,
  total: 0,
  defaultPageSize: 10,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "20", "30", "40"],
  showTotal: (total: number) => `共 ${total} 条数据`,
});
const data = reactive({
  filterForm: {
    Key: "",
    RegionId: 0,
    CompanyId: 0,
    ApproveNode: 0,
    ApprovalMatters: 0,
    Approves: 0,
  },
});
const pendingApproval = async () => {
  const { Data, Success, Message, Total } = await getPendingApprovalList({
    ApproveNode: data.filterForm.ApproveNode,
    ApprovalMatters: data.filterForm.ApprovalMatters,
    Approves: data.filterForm.Approves,
    PageIndex: pagination.current,
    PageSize: pagination.pageSize,
    CompanyId: data.filterForm.CompanyId,
    RegionId: data.filterForm.RegionId,
    Key: data.filterForm.Key,
  });
  if (Success) {
    tableData.value = Data;
    pagination.total = Total;
  } else {
    message.warning(Message);
  }
};

// pendingApproval();

// 判断页面是从相关二级页面 返回
onActivated(() => {
  if (route.meta.flag) {
    //  保留筛选条件
  } else {
    data.filterForm = {
      Key: "",
      RegionId: 0,
      CompanyId: 0,
      ApproveNode: 0,
      ApprovalMatters: 0,
      Approves: 0,
    };
    pagination.current = 1;
    pagination.pageSize = 10;
  }

  pendingApproval();
});
// 数据筛选
const DataSearch = (val: any) => {
  data.filterForm = val;
  pagination.current = 1;
  pendingApproval();
};
const handleTableChange = (row: any) => {
  pagination.current = row.current;
  pagination.pageSize = row.pageSize;
  pendingApproval();
};
// 处理审批
const handleApprove = (row: any) => {
  const ApprovalMatters = row.ApprovalMatters;
  const Id = row.Id;
  const TraceId = row.TraceId;
  router.push({
    path: "/signsure/detail",
    query: { type: ApprovalMatters, id: Id, traceId: TraceId },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { title: '待审批' }),
    _createVNode(ApproveFilter, {
      titleFlag: '待审批',
      onDataSearch: DataSearch
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_table, {
        columns: _unref(SIGNSURE),
        "data-source": tableData.value,
        pagination: _unref(pagination),
        scroll: { x: 1000 },
        onChange: handleTableChange
      }, {
        btn: _withCtx(({ text: record }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btnClass",
              onClick: ($event: any) => (handleApprove(record))
            }, " 处理审批 ", 8, _hoisted_3)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "pagination"])
    ])
  ], 64))
}
}

})